import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setGsGalleryData } from "../car-details/actions";
import CarDetailOuterImagesRevamp from "./component";

const mapStateToProps = ({
    carDetails: {
        content,
        config,
        galleryProps: {
            isOpen
        }
    },
    abExperiment: {
        webCarTour
    }
}) => ({
    content,
    isOpen,
    webCarTour,
    config
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setGsGalleryDataConnect: setGsGalleryData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarDetailOuterImagesRevamp);
